<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">

    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="分类名称：">
              <el-input v-model="classType" clearable placeholder="请输入分类名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="add-column-btn" @click="search">查询</el-button>
              <el-button class="dayin-column-btn" @click="toResetting">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <!--        <el-scrollbar style="height: 100%; width: 100%">-->
        <el-row style="width: 100%">
          <el-table :data="tableData" border fit highlight-current-row style="width: 100%">
            <el-table-column
              type="index"
              :index="sequence()"
              label="序号"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column label="分类名称" align="center" prop="categoryName">
            </el-table-column>
            <el-table-column label="是否有效" align="center" prop="showFlag">
              <template slot-scope="scope">
                <span v-if="scope.row.isValid == '0'">无效</span>
                <span v-if="scope.row.isValid == '1'">有效</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <!-- <el-popconfirm :title='scope.row.showFlag === "0" ? "确定展示吗？" : "确定隐藏吗？"'
                               @onConfirm="updateCategory(scope.row.isValid, scope.row.id)">
                  <el-button slot="reference" type="text" class="textBtn">
                    {{ scope.row.isValid == '1' ? '隐藏' : '展示' }}
                  </el-button>
                </el-popconfirm> -->
                <el-button type="text"
                 @click="toEdit(scope.row)" class="textBtn">编辑
                </el-button>
                <el-popconfirm title='确定删除吗？'
                               @onConfirm="toDelect(scope.row.categoryCode)">
                  <el-button slot="reference" type="text" class="textBtn">
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <!--        </el-scrollbar>-->
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]"
                       :page-size="queryInfo.pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

      <!-- 编辑弹窗 -->
      <el-dialog title="编辑菜品分类" :visible.sync="classTypeModal" width="500px">
        <el-form :model="classTypeForm" :rules="classTypeRules">
          <el-form-item label="分类名称" label-width="80px" prop="categoryName">
            <el-input v-model="classTypeForm.categoryName"></el-input>
          </el-form-item>
          <el-form-item label="排序" label-width="80px" prop="sequence">
            <el-input v-model="classTypeForm.sequence" type="number" :min="'1'"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="classTypeModal = false" class="dayin-column-btn">取 消</el-button>
          <el-button @click="setEdit" class="add-column-btn">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      height: window.innerHeight - 256, //表格高度
      classType: '', //分类名称
      tableData: [],
      classTypeModal: false,  //编辑弹窗是否显示
      classTypeForm: {
        categoryCode: '',
        categoryName: '',
        sequence: '',
      },
      classTypeRules: {
        sequence: [{ required: true, message: '只能输入正整数', trigger: 'change' },
          {
            pattern: /^[1-9]\d*$/,
            message: '只能输入正整数',
          }],
        categoryName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      },
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 10,
        //查询条件
        condition: {
          categoryName: '',
          merchantCode: JSON.parse(localStorage.getItem('merchantCode'))
        }
      },
      total: 0,
    }
  },
  created () {
    this.getListData()
    window.addEventListener('resize', this.getHeight)
  },
  mounted () {
    this.loading = false
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    //删除
    toDelect (code) {
      this.$http.post('/eleWaimaiProductCategory/deleteCategory', {
        categoryCode: code
      }).then(res => {
        console.log(res.data)
        if (res.data.code === 200) {
          this.getListData()
          this.$message({
            type: 'success',
            message: '操作成功！'
          })
        } else if (res.data.code === 400) {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      })
    },
    //编辑
    toEdit (value) {
      this.classTypeModal = true
      this.classTypeForm.categoryCode = value.categoryCode
      this.classTypeForm.categoryName = value.categoryName
      this.classTypeForm.sequence = value.sequence
    },
    setEdit () {
      this.$http.post('/eleWaimaiProductCategory/updateCategoryWithRelation',
        this.classTypeForm).then(res => {
        console.log(res.data)
        if (res.data.code === 200) {
          this.classTypeModal = false
          this.getListData()
          this.$message({
            type: 'success',
            message: '操作成功！'
          })
        }
      })
    },
    //展示隐藏
    updateCategory (val, id) {
      let isValid = ''
      if (val === 0) {
        isValid = 1
      } else {
        isValid = 0
      }
      this.$http.post('/eleWaimaiProductCategory/update', {
        isValid,
        id
      }).then(res => {
        if (res.data.code === 200) {
          this.getListData()
          this.$message({
            type: 'success',
            message: '操作成功！'
          })
        }
      })
    },
    //重置
    toResetting () {
      this.queryInfo.condition.categoryName = ''
      this.getListData()
    },
    //条件查询
    search () {
      this.queryInfo.condition.categoryName = this.classType
      this.getListData()
    },
    // 监听 pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getListData()
    },
    // 监听 页码值 改变事件
    handleCurrentChange (newSize) {
      this.queryInfo.currPage = newSize
      this.getListData()
    },

    getListData () {
      // 获取列表
      var that = this
      that.$http.post('/eleWaimaiProductCategory/list', that.queryInfo).then(res => {
        if (res.data.code == 200) {
          that.total = res.data.data.count
          that.queryInfo.currPage = res.data.data.currPage
          that.tableData = res.data.data.data
        }
      })
    },
    sequence () {
      return (this.queryInfo.currPage - 1) * this.queryInfo.pageSize + 1
    },
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - 256
    },
  },
}
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}

.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;

    .el-select > .el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}

/deep/ .el-scrollbar__view {
  min-width: 100%;
}

/deep/ .el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/ .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

.add-column-btn {
  background-color: #f59a23;
  color: #000000;
  border: none;
}

.dayin-column-btn {
  border: 1px solid #DCDFE6;
  background: transparent;
  color: #000000;
}

.dayin-column-btn:hover {
  background: #fde7ca;
  color: #000000;
}

.dayin-column-btn:active {
  background: #fde7ca;
  color: #000000;
  border: none;
}

.textBtn {
  color: #f59a23;
  padding: 0 5px;
}

/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

</style>

